import type { ApiClient } from './client';

// Saving files from the browser: the API's own (behind the bearer token, so never a plain link) and blobs.

/** Saves `blob` as `name` through a temporary `<a download>`. */
export function saveBlob(blob: Blob, name: string): void {
  const url = URL.createObjectURL(blob);
  startDownload(url, name);
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

/**
 * The file name a `Content-Disposition` header suggests: `filename*=UTF-8''…` before `filename=`, else `fallback`.
 */
export function dispositionFileName(header: string | null | undefined, fallback: string): string {
  const h = header ?? '';
  const star = /filename\*\s*=\s*(?:UTF-8'[^']*')?([^;]+)/i.exec(h);
  if (star)
    try {
      return decodeURIComponent(star[1].trim().replace(/^"|"$/g, ''));
    } catch {
      /* a malformed escape: the plain name, if any */
    }
  const plain = /filename\s*=\s*(?:"([^"]*)"|([^;]+))/i.exec(h);
  return (plain?.[1] ?? plain?.[2])?.trim() || fallback;
}

/** Follows a `blob:` or same-origin URL through a hidden anchor so the browser saves instead of navigating. */
export function startDownload(url: string, name = ''): void {
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/** Fetches `path` with the client's bearer token and saves it as `name`. */
export async function download(client: ApiClient, path: string, name: string): Promise<void> {
  const response = await client.requestRaw('GET', path, undefined, { accept: '*/*' });
  saveBlob(await response.blob(), name);
}
